import diff from 'deep-diff';
import moment from 'jalali-moment';
import { diff as diffObjs } from 'deep-object-diff';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getVisibleMenuItems } from './PermissionManager';

export const getDiff = (dataFirst, dataSecond) => {
  const diffData = diff(dataFirst, dataSecond);
  let changedData = {};

  if (diffData === undefined) {
    return { isDiff: false, changedData };
  } else {
    diffData.forEach(item => (changedData[item.path[0]] = dataFirst[item.path[0]]));
    return { isDiff: true, changedData };
  }
};

let lenSpecificKey = (items, val) => items.filter(i => i.page === val).length;

export const permissionTypes = {
  owner: 'owner',
  instructor: 'instructor',
  cc: 'course_creator',
  admin: 'admin',
};

export const getMenuBasedOnPermissions = (permissions, items, roles, menuParam) => {
  let hasMenu = Boolean(menuParam);
  let menuItems = items;
  let asideItems = menuItems.aside.items;

  // let {instructor, admin, cc, owner} = permissionTypes;
  // let homeObj = getMenuObj('داشبورد', 'home', true, '');
  // let meObj = getMenuObj('صفحه من', 'my page', true, 'me');
  // let orgsManagement = getMenuObj('مدیریت سازمان ها', 'orgs management', true, 'orgs');
  // let coursesManagement = getMenuObj('مدیریت دوره ها', 'courses management', true, 'courses');
  // let myCreateCourseDemands = getMenuObj(
  //   'دوره های من',
  //   'my course run demands management',
  //   true,
  //   'my-course-run-demands'
  // );

  // ADD DASHBOARD PAGE BASED ON "MENU" PARAM
  // if (lenSpecificKey(asideItems, '') === 0) {
  //   if (hasMenu) {
  //     if (menuParam.includes('home')) asideItems = [...asideItems, homeObj];
  //   } else asideItems = [...asideItems, homeObj];
  // }
  //
  // // ADD "ME" AND "COURSES" PAGE BASED ON "INSTRUCTOR" ROLE AND "MENU" PARAM
  // if (roles.includes(instructor)) {
  //   if (lenSpecificKey(asideItems, 'me') === 0) {
  //     if (hasMenu) {
  //       if (menuParam.includes('me')) asideItems = [...asideItems, meObj];
  //     } else asideItems = [...asideItems, meObj];
  //   }
  //
  //   if (lenSpecificKey(asideItems, 'courses') === 0) {
  //     if (hasMenu) {
  //       if (menuParam.includes('courses')) asideItems = [...asideItems, coursesManagement];
  //     } else asideItems = [...asideItems, coursesManagement];
  //   }
  // }
  //
  // // ADD "COURSES" AND "ORGS" PAGE BASED ON "OWNER" ROLE AND "MENU" PARAM
  // if (roles.includes(owner)) {
  //   if (lenSpecificKey(asideItems, 'orgs') === 0) {
  //     if (hasMenu) {
  //       if (menuParam.includes('orgs')) asideItems = [...asideItems, orgsManagement];
  //     } else asideItems = [...asideItems, orgsManagement];
  //   }
  //
  //   if (lenSpecificKey(asideItems, 'course-run-demands') === 0) {
  //     if (hasMenu) {
  //       if (menuParam.includes('course-run-demands')) asideItems = [...asideItems];
  //     } else asideItems = [...asideItems];
  //   }
  //
  //   if (lenSpecificKey(asideItems, 'courses') === 0) {
  //     if (hasMenu) {
  //       if (menuParam.includes('courses')) asideItems = [...asideItems, coursesManagement];
  //     } else asideItems = [...asideItems, coursesManagement];
  //   }
  // }
  //
  // // ADD "COURSES" PAGE BASED ON "COURSE CREATOR" ROLE AND "MENU" PARAM
  // if (roles.includes(cc)) {
  //   if (lenSpecificKey(asideItems, 'course-run-demands') === 0) {
  //     if (hasMenu) {
  //       if (menuParam.includes('course-run-demands')) asideItems = [...asideItems];
  //     } else asideItems = [...asideItems];
  //   }
  //
  //   if (lenSpecificKey(asideItems, 'courses') === 0) {
  //     if (hasMenu) {
  //       if (menuParam.includes('courses')) asideItems = [...asideItems, coursesManagement];
  //     } else asideItems = [...asideItems, coursesManagement];
  //   }
  // }
  //
  // // ADD "ORGS" PAGE BASED ON "ADMIN" ROLE AND "MENU" PARAM
  // if (roles.includes(admin)) {
  //   if (lenSpecificKey(asideItems, 'orgs') === 0) {
  //     if (hasMenu) {
  //       if (menuParam.includes('orgs')) asideItems = [...asideItems, orgsManagement];
  //     } else {
  //       asideItems = [...asideItems, orgsManagement];
  //     }
  //   }
  // }

  // menuItems.aside.items = asideItems;

  menuItems.aside.items = getVisibleMenuItems(permissions, roles);

  return menuItems;
};

// function getVisibleMenuItems(selectedRole) {
//   let homeObj = getMenuObj('داشبورد', 'home', true, '');
//   let meObj = getMenuObj('صفحه من', 'my page', true, 'me');
//   let orgsManagement = getMenuObj('مدیریت سازمان ها', 'orgs management', true, 'orgs');
//   let coursesManagement = getMenuObj('مدیریت دوره ها', 'courses management', true, 'courses');
//   let myCreateCourseDemands = getMenuObj(
//     'دوره های من',
//     'my course run demands management',
//     true,
//     'my-course-run-demands'
//   );
//
//   let all = []
//
//   switch (selectedRole?.name) {
//     case permissionTypes.owner: {
//       all.push(homeObj)
//       all.push(orgsManagement)
//       break;
//     }
//     case permissionTypes.admin: {
//       all.push(homeObj)
//       all.push(orgsManagement)
//       break;
//     }
//     case permissionTypes.cc: {
//       all.push(homeObj)
//       all.push(coursesManagement)
//       break;
//     }
//     case permissionTypes.instructor: {
//       all.push(homeObj)
//       break;
//     }
//   }
//   // all.push(meObj)
//
//   return all
// }

// Detect Browser
export const detectBrowserName = ua => {
  let browserName;

  switch (true) {
    case ua.indexOf('Opera') !== -1:
      browserName = 'Opera';
      break;

    case ua.indexOf('MSIE') !== -1:
      browserName = 'Microsoft Internet Explorer';
      break;

    case ua.indexOf('Chrome') !== -1:
      browserName = 'Chrome';
      break;

    case ua.indexOf('Safari') !== -1:
      browserName = 'Safari';
      break;

    case ua.indexOf('Firefox') !== -1:
      browserName = 'Firefox';
      break;

    default:
      break;
  }

  return browserName;
};

export const allRoleStatus = {
  rejected: 'rejected',
  forReview: 'for_review',
  accepted: 'accepted',
};

export const courseStatus = {
  inProcess: 'in_process',
  forReview: 'for_review',
  done: 'done',
};

export const ConvertToJalali = date => {
  return moment(date, 'YYYY/MM/DD')
    .locale('fa')
    .format('YYYY/MM/DD');
};

export function renameFileData(data, name) {
  let fileData = new FormData();

  let type = data.type.split('/').slice(-1)[0];
  let newName = `${name}.${type}`;
  fileData.append(name, data, newName);

  return fileData.get(name);
}

export function generateFormData(data) {
  let fileData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (!!value) {
      if (Array.isArray(value)) value.forEach(arrValue => fileData.append(key, arrValue));
      else fileData.append(key, value);
    }
  });

  return fileData;
}

export function minLenGenerator(value) {
  return `لطفا بیش از ${value} کاراکتر وارد کنید`;
}

export function maxLenGenerator(value) {
  return `لطفا کمتر از ${value} کاراکتر وارد کنید`;
}

export function convertToJalali(date) {
  return moment(date, 'YYYY/MM/DD')
    .locale('fa')
    .format('YYYY/MM/DD');
}

/**
 *
 * @param {object} data error object
 * @param {function} handleError (react hook form) callback function to field errors
 */
export function handleAPIErrors(data, handleError) {
  let noneFieldErrors = [];
  for (const errorName in data) {
    if (errorName === 'detail') noneFieldErrors.push(data[errorName]);
    else handleError(errorName, data[errorName]);
  }

  return noneFieldErrors;
}

export function getDiffObjs(originalObj, updatedObj) {
  let tempOriginalObj = {};
  Object.keys(updatedObj).forEach(key => {
    if (originalObj) tempOriginalObj[key] = originalObj[key];
    else tempOriginalObj[key] = undefined;
  });

  let diffedData = diffObjs(tempOriginalObj, updatedObj);

  Object.entries(updatedObj).forEach(([key, value]) => {
    if (value instanceof File) {
      diffedData[key] = value;
    }
  });

  if (Object.keys(diffedData).length) return diffedData;
}

export function generateOptions(data, { label, value, customLabel }) {
  let tempData = [];
  if (data) {
    data.forEach(item => {
      let tempOption = {};
      tempOption = { label: customLabel ? customLabel(item) : item[label], value: item[value] };
      tempData.push(tempOption);
    });

    return tempData;
  }

  return [];
}

export function getFullPath(path) {
  return `${process.env.REACT_APP_MEDIA_URL}${path}`;
}
